const newRenderAllCartGoals = () => {
        let customRootElementCartPage = window.tlCartGoalEmbed.cartDisplay;
        let customRootElementCartDraw = window.tlCartGoalEmbed.cartDrawDisplay;

        const allCartGoalContainers = document.querySelectorAll(".tl__cart-goal__container__drawer, .tl-custom-cart-goal-container");
        if (allCartGoalContainers.length) {
            allCartGoalContainers.forEach(ele => ele.remove());
        }

        // inject cart goals into cart drawer and cart page
        if (customRootElementCartPage.selector || customRootElementCartDraw.selector) {
            if (customRootElementCartPage.selector) {
                if(customRootElementCartPage.position === "prepend"){
                    document.querySelectorAll(customRootElementCartPage.selector).forEach((ele, index) => {
                        let htmlObject = document.createElement('div');
                        htmlObject.classList.add('tl-custom-cart-goal-container');
                        htmlObject.innerHTML = window.tlCartGoalEmbed.renderCartGoal(index);
                        ele.prepend(htmlObject)
                    });
                } else {
                    let position = customRootElementCartPage.position === "before" ? "beforebegin" : "afterend";
                    document.querySelectorAll(customRootElementCartPage.selector).forEach((ele, index) => ele.insertAdjacentHTML(position, window.tlCartGoalEmbed.renderCartGoal(index)));
                }
            }
            if (customRootElementCartDraw.selector) {
                let position;
                if (customRootElementCartDraw.position === "prepend") {
                    position = "prepend";
                    document.querySelectorAll(customRootElementCartDraw.selector).forEach((ele, index) => {
                        let htmlObject = document.createElement('div');
                        htmlObject.classList.add('tl-custom-cart-goal-container');
                        htmlObject.innerHTML = window.tlCartGoalEmbed.renderCartGoal(index);
                        ele.prepend(htmlObject)});
                } else {
                    position = customRootElementCartDraw.position === "before" ? "beforebegin" : "afterend";
                    document.querySelectorAll(customRootElementCartDraw.selector).forEach((ele, index) => ele.insertAdjacentHTML(position, window.tlCartGoalEmbed.renderCartGoal(index)));
                }

            }
        } else {
            
            document.querySelectorAll(window.tlCartGoalEmbed.ROOT_SELECTOR_ELEMENT).forEach((ele, index) => {
                ele.insertAdjacentHTML(window.tlCartGoalEmbed.ROOT_SELECTOR_POSITION, window.tlCartGoalEmbed.renderCartGoal(index))
            });
        }

        window.tlCartGoalEmbed.addTrackImpressionEvent();
    }
Object.defineProperty(window, "tlCartGoalEmbed", {
  set(value) {
    if (value) {
      value.renderAllCartGoals = newRenderAllCartGoals
    }
    Object.defineProperty(window, "tlCartGoalEmbed", {
      value,
      writable: true,
      configurable: true
    });
  },
  configurable: true
});

setTimeout(()=>{
  if(window.tlCartGoalEmbed){
    if(window.location.pathname !== '/cart'){
      window.tlCartGoalEmbed.ROOT_SELECTOR_ELEMENT = '.drawer-content.drawer-cart__content'
    }
  }
},1000)



